export default {
  inputOptions: { showDialCode: false },
  dropdownOptions: {
    showSearchBox: true,
    showDialCodeInSelection: true,
  },
  preferredCountries: ['KR'],
  onlyCountries: [
    'AF',
    'AL',
    // 'DZ',
    // 'AD',
    // 'AO',
    // 'AR',
    'AM',
    // 'AW',
    'AU',
    'AT',
    'AZ',
    'BH',
    'BD',
    'BY',
    'BE',
    // 'BZ',
    // 'BJ',
    // 'BT',
    // 'BO',
    'BA',
    // 'BW',
    // 'BR',
    'BN',
    'BG',
    // 'BF',
    // 'BI',
    'KH',
    // 'CM',
    'CA',
    // 'CV',
    // 'CF',
    // 'TD',
    // 'CL',
    'CN',
    // 'CO',
    // 'CD',
    // 'CG',
    // 'CK',
    // 'CR',
    // 'CI',
    'HR',
    // 'CU',
    'CY',
    'CZ',
    'DK',
    // 'DJ',
    // 'EC',
    'EG',
    // 'SV',
    // 'GQ',
    // 'ER',
    'EE',
    // 'ET',
    // 'FK',
    // 'FO',
    // 'FJ',
    'FI',
    'FR',
    // 'GF',
    // 'PF',
    // 'GA',
    // 'GM',
    // 'GE',
    'DE',
    // 'GH',
    // 'GI',
    'GR',
    // 'GL',
    // 'GP',
    // 'GT',
    // 'GN',
    // 'GW',
    // 'GY',
    // 'HT',
    // 'HN',
    'HK',
    'HU',
    // 'IS',
    'IN',
    'ID',
    // 'IR',
    // 'IQ',
    'IE',
    'IL',
    'IT',
    'JP',
    'JO',
    // 'KZ',
    // 'KE',
    // 'KI',
    'KW',
    'KG',
    'LA',
    'LV',
    'LB',
    // 'LS',
    // 'LR',
    // 'LY',
    // 'LI',
    'LT',
    'LU',
    'MO',
    'MK',
    // 'MG',
    // 'MW',
    'MY',
    // 'MV',
    // 'ML',
    'MT',
    // 'MH',
    // 'MQ',
    // 'MR',
    // 'MU',
    // 'MX',
    // 'FM',
    // 'MD',
    // 'MC',
    // 'MN',
    // 'ME',
    // 'MA',
    // 'MZ',
    'MM',
    // 'NA',
    // 'NR',
    // 'NP',
    'NL',
    // 'NC',
    'NZ',
    // 'NI',
    // 'NE',
    // 'NG',
    'NO',
    'OM',
    'PK',
    // 'PW',
    // 'PS',
    // 'PA',
    'PG',
    // 'PY',
    // 'PE',
    'PH',
    'PL',
    'PT',
    // 'QA',
    // 'RE',
    'RO',
    'RU',
    // 'RW',
    // 'SH',
    // 'PM',
    // 'WS',
    // 'SM',
    // 'ST',
    'SA',
    // 'SN',
    'RS',
    // 'SC',
    // 'SL',
    'SG',
    'SK',
    'SI',
    // 'SB',
    // 'SO',
    // 'ZA',
    'KR',
    // 'SS',
    'ES',
    // 'LK',
    // 'SD',
    // 'SR',
    // 'SZ',
    'SE',
    'CH',
    // 'SY',
    'TW',
    'TJ',
    // 'TZ',
    'TH',
    // 'TL',
    // 'TG',
    // 'TO',
    // 'TN',
    'TR',
    'TM',
    // 'UG',
    'UA',
    'AE',
    'GB',
    'US',
    // 'UY',
    'UZ',
    // 'VU',
    // 'VE',
    'VN',
    // 'WF',
    'YE',
    // 'ZM',
    // 'ZW',
  ],
};
